function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "url(#paint0_radial_20018186_51900)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.59472 24.1478C6.21009 23.7037 5.85713 23.2332 5.53845 22.7397L12.2794 15.9998L5.53845 9.25916C5.85731 8.76599 6.21026 8.29572 6.59472 7.85178L14.7431 15.9998L6.59472 24.1478ZM4.65228 10.8867C4.38782 11.4725 4.16972 12.0781 4 12.6981L7.30188 15.9998L4 19.3015C4.16983 19.9214 4.38792 20.527 4.65228 21.1129L9.7656 15.9998L4.65228 10.8867ZM16.0003 17.259L7.85196 25.407C8.29549 25.792 8.76582 26.145 9.25941 26.4632L16.0003 19.7226L22.7406 26.4632C23.2342 26.145 23.7045 25.792 24.148 25.407L16.0003 17.259ZM21.1137 27.3501L15.9997 22.2363L10.8863 27.3494C11.4723 27.6136 12.0779 27.8317 12.6978 28.0016L15.9997 24.6999L19.3022 28.0016C19.9221 27.8307 20.5277 27.612 21.1137 27.3473V27.3501ZM16.0003 14.7426L24.148 6.5946C23.7043 6.21005 23.234 5.85733 22.7406 5.53907L16.0003 12.279L9.25941 5.53907C8.76599 5.85733 8.29567 6.21005 7.85196 6.5946L16.0003 14.7426ZM27.3477 21.1129C27.6122 20.5271 27.8303 19.9214 28 19.3015L24.6981 15.9998L28 12.6981C27.8302 12.078 27.6121 11.4721 27.3477 10.886L22.2344 15.9998L27.3477 21.1129ZM19.7206 15.9998L26.4615 9.25916C26.1429 8.76587 25.7899 8.29559 25.4053 7.85178L17.2596 15.9998L25.408 24.1478C25.7926 23.7037 26.1456 23.2332 26.4643 22.7397L19.7206 15.9998ZM15.9997 9.76533L21.1137 4.65225C20.5277 4.38802 19.9221 4.16994 19.3022 4L15.9997 7.30172L12.6978 4C12.078 4.17024 11.4724 4.38831 10.8863 4.65225L15.9997 9.76533Z",
  fill: "url(#paint1_radial_20018186_51900)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.59472 24.1478C6.21009 23.7037 5.85713 23.2332 5.53845 22.7397L12.2794 15.9998L5.53845 9.25916C5.85731 8.76599 6.21026 8.29572 6.59472 7.85178L14.7431 15.9998L6.59472 24.1478ZM4.65228 10.8867C4.38782 11.4725 4.16972 12.0781 4 12.6981L7.30188 15.9998L4 19.3015C4.16983 19.9214 4.38792 20.527 4.65228 21.1129L9.7656 15.9998L4.65228 10.8867ZM16.0003 17.259L7.85196 25.407C8.29549 25.792 8.76582 26.145 9.25941 26.4632L16.0003 19.7226L22.7406 26.4632C23.2342 26.145 23.7045 25.792 24.148 25.407L16.0003 17.259ZM21.1137 27.3501L15.9997 22.2363L10.8863 27.3494C11.4723 27.6136 12.0779 27.8317 12.6978 28.0016L15.9997 24.6999L19.3022 28.0016C19.9221 27.8307 20.5277 27.612 21.1137 27.3473V27.3501ZM16.0003 14.7426L24.148 6.5946C23.7043 6.21005 23.234 5.85733 22.7406 5.53907L16.0003 12.279L9.25941 5.53907C8.76599 5.85733 8.29567 6.21005 7.85196 6.5946L16.0003 14.7426ZM27.3477 21.1129C27.6122 20.5271 27.8303 19.9214 28 19.3015L24.6981 15.9998L28 12.6981C27.8302 12.078 27.6121 11.4721 27.3477 10.886L22.2344 15.9998L27.3477 21.1129ZM19.7206 15.9998L26.4615 9.25916C26.1429 8.76587 25.7899 8.29559 25.4053 7.85178L17.2596 15.9998L25.408 24.1478C25.7926 23.7037 26.1456 23.2332 26.4643 22.7397L19.7206 15.9998ZM15.9997 9.76533L21.1137 4.65225C20.5277 4.38802 19.9221 4.16994 19.3022 4L15.9997 7.30172L12.6978 4C12.078 4.17024 11.4724 4.38831 10.8863 4.65225L15.9997 9.76533Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 7,
  fill: "url(#paint2_linear_20018186_51900)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8143 29V26.0171L20.5 21H22.7629L24.8543 24.28L26.9571 21H29.0943L25.78 26.0171V29H23.8143Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_20018186_51900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(34.8213 32.0677) scale(47.1106 47.1052)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20018186_51900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.116 28.0524) scale(35.333 35.3313)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20018186_51900",
  x1: 18,
  y1: 18,
  x2: 32,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#999999"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})));
function SvgYAlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYAlex);
export default __webpack_public_path__ + "static/media/yAlex.4ebafb3f55819850a3bdd3753a02dc1a.svg";
export { ForwardRef as ReactComponent };